/* Filter Enhancement JavaScript - Oil Slick */
(function() {
  'use strict';

  // Wait for DOM
  document.addEventListener('DOMContentLoaded', function() {
    initFilterEnhancements();
  });

  function initFilterEnhancements() {
    // Format filter dropdown options on load
    formatFilterDropdowns();
    
    // Initialize mobile filter toggle
    initMobileFilters();
    
    // Initialize quick filters
    initQuickFilters();
    
    // Add filter count badges
    addFilterBadges();
  }

  function formatFilterDropdowns() {
    var tagFilter = document.getElementById('tag_filter');
    if (!tagFilter) return;

    // Format each option
    Array.from(tagFilter.options).forEach(function(option) {
      var text = option.text;
      
      // Skip "All" option
      if (text.toLowerCase().startsWith('all ')) return;
      
      // Format the text
      text = formatFilterText(text);
      option.text = text;
    });
  }

  function formatFilterText(text) {
    // Replace underscores and hyphens
    text = text.replace(/_/g, ' ').replace(/-/g, ' ');
    
    // Handle prefix:value patterns
    if (text.includes(':')) {
      var parts = text.split(':');
      var prefix = capitalize(parts[0].trim());
      var value = capitalize(parts[1].trim());
      text = prefix + ': ' + value;
    } else {
      text = capitalize(text);
    }
    
    // Standardize length format
    text = text.replace(/(\d+)in/gi, '$1"');
    text = text.replace(/(\d+)IN/gi, '$1"');
    
    // Fix common terms
    var replacements = {
      'Borosilicate': 'Borosilicate Glass',
      'Brand Highlight': 'Brand Feature',
      'Travel Friendly': 'Travel Friendly',
      'Made In Usa': 'Made in USA',
      'Glass Bong': 'Glass Bong',
      'Flower Smoking': 'Flower Smoking'
    };
    
    Object.keys(replacements).forEach(function(key) {
      text = text.replace(new RegExp(key, 'gi'), replacements[key]);
    });
    
    return text;
  }

  function capitalize(str) {
    return str.split(' ').map(function(word) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join(' ');
  }

  function initMobileFilters() {
    var sidebar = document.getElementById('collection-sidebar');
    var filterBar = document.querySelector('.mobile-filter-bar');
    
    if (!sidebar || !filterBar) return;

    // Close on outside click
    document.addEventListener('click', function(e) {
      if (sidebar.classList.contains('mobile-open')) {
        if (!sidebar.contains(e.target) && !filterBar.contains(e.target)) {
          sidebar.classList.remove('mobile-open');
        }
      }
    });

    // Close on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && sidebar.classList.contains('mobile-open')) {
        sidebar.classList.remove('mobile-open');
      }
    });
  }

  function initQuickFilters() {
    var quickFilters = document.querySelectorAll('.quick-filter-btn');
    
    quickFilters.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        // Add active class
        quickFilters.forEach(function(b) { b.classList.remove('active'); });
        this.classList.add('active');
      });
    });
  }

  function addFilterBadges() {
    var filterSections = document.querySelectorAll('.sidebar__collection-filter');
    
    filterSections.forEach(function(section) {
      var checkboxes = section.querySelectorAll('input[type="checkbox"]');
      var title = section.querySelector('.toggle');
      
      if (title && checkboxes.length > 0) {
        // Check if badge already exists
        if (!title.querySelector('.filter-badge')) {
          var badge = document.createElement('span');
          badge.className = 'filter-badge';
          badge.textContent = checkboxes.length;
          title.insertBefore(badge, title.querySelector('.icon-down-arrow'));
        }
      }
    });
  }

  // Expose for external use
  window.OilSlickFilters = {
    formatFilterText: formatFilterText,
    refresh: initFilterEnhancements
  };
})();
